import { c as _c } from "react/compiler-runtime";
import React, { Dispatch, ReactElement, ReactNode, SetStateAction, memo, useMemo, useState } from 'react';
import { BasicStore } from '../interfaces';
import CheckboxComponent from '../../checkbox/checkbox.component';
import ImageComponent from '@spa/components/image-component/image.component';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import classNames from 'clsx';
import styles from './store-filter.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
interface Props {
  readonly allBasicStores: ReadonlyArray<BasicStore>;
  readonly setShownBasicStores: Dispatch<SetStateAction<ReadonlyArray<BasicStore>>>;
  readonly selectedAssortments: ReadonlyArray<string>;
  readonly setSelectedAssortments: Dispatch<SetStateAction<Array<string>>>;
}
const StoreFilterComponent = t0 => {
  const $ = _c(29);
  const {
    allBasicStores,
    setShownBasicStores,
    selectedAssortments,
    setSelectedAssortments
  } = t0;
  const [isExpanded, setIsExpanded] = useState(false);
  const {
    formatMessage
  } = useNamespacedIntl("storefinder");
  let resultSet;
  if ($[0] !== allBasicStores) {
    resultSet = new Set();
    for (const {
      assortments
    } of allBasicStores) {
      for (const assort of assortments) {
        resultSet.add(assort);
      }
    }
    $[0] = allBasicStores;
    $[1] = resultSet;
  } else {
    resultSet = $[1];
  }
  let t1;
  if ($[2] !== resultSet) {
    t1 = Array.from(resultSet);
    $[2] = resultSet;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const allAssortments = t1;
  let t2;
  if ($[4] !== allBasicStores || $[5] !== selectedAssortments || $[6] !== setSelectedAssortments || $[7] !== setShownBasicStores) {
    t2 = assortment => {
      const newSelectedAssortments = selectedAssortments.includes(assortment) ? selectedAssortments.filter(item => item !== assortment) : [...selectedAssortments, assortment];
      setSelectedAssortments(newSelectedAssortments);
      const filteredBasicStores = allBasicStores.filter(store => newSelectedAssortments.every(assortment_0 => store.assortments.includes(assortment_0)));
      setShownBasicStores(filteredBasicStores);
    };
    $[4] = allBasicStores;
    $[5] = selectedAssortments;
    $[6] = setSelectedAssortments;
    $[7] = setShownBasicStores;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const handleCheckboxChange = t2;
  let t3;
  if ($[9] !== isExpanded) {
    t3 = classNames(styles["store-filter"], {
      [styles["store-filter--expanded"]]: isExpanded
    });
    $[9] = isExpanded;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== isExpanded) {
    t4 = () => setIsExpanded(!isExpanded);
    $[11] = isExpanded;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== formatMessage) {
    t5 = formatMessage("refineSearch");
    $[13] = formatMessage;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ImageComponent src="/assets/icons/arrow_forward_bold.svg" height={16} width={16} alt="" className={styles["store-filter__filter-button-arrow"]} aria-hidden="true" />;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t4 || $[17] !== t5) {
    t7 = <button className={`${styles["store-filter__filter-button"]}`} onClick={t4}>{t5}{t6}</button>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== allAssortments || $[20] !== formatMessage || $[21] !== handleCheckboxChange || $[22] !== isExpanded || $[23] !== selectedAssortments) {
    t8 = isExpanded && <div className={styles["store-filter__filters"]}>{allAssortments.map(assortment_1 => {
        const translatedAssortment = formatMessage(`refineSearchOptions.${assortment_1.toLowerCase()}`);
        return <div className={styles["store-filter__filter"]} key={assortment_1}><CheckboxComponent id={translatedAssortment} name={translatedAssortment} value={translatedAssortment} checked={selectedAssortments.includes(assortment_1)} label={translatedAssortment} handleCheckboxChange={() => handleCheckboxChange(assortment_1)} /></div>;
      })}</div>;
    $[19] = allAssortments;
    $[20] = formatMessage;
    $[21] = handleCheckboxChange;
    $[22] = isExpanded;
    $[23] = selectedAssortments;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== t3 || $[26] !== t7 || $[27] !== t8) {
    t9 = <div className={t3}>{t7}{t8}</div>;
    $[25] = t3;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
};
export default memo(StoreFilterComponent);